const datetimeFormats = {
  pl: {
    short: { year: 'numeric', month: '2-digit', day: '2-digit' }, // 12.02.2025
    long: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }, // środa, 12 lutego 2025
    weekdayDate: { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }, // środa, 12.06.2026
    weekdayDayMonth: { weekday: 'long', day: 'numeric', month: 'long' }, // środa, 12 lutego
    weekdayDayMonthNumber: { weekday: 'long', day: '2-digit', month: '2-digit' }, // środa, 12.02
    dayMonthYear: { day: '2-digit', month: '2-digit', year: 'numeric' }, // 12.02.2025
    monthYear: { month: 'long', year: 'numeric' }, // luty 2025
    dayMonthTextYear: { day: 'numeric', month: 'long', year: 'numeric' }, // 12 lutego 2025
    dayMonthTextYearTime: { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' } // 12 lutego 2025 14:30
  },
  en: {
    short: { year: 'numeric', month: 'short', day: 'numeric' }, // Feb 12, 2025
    long: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }, // Wednesday, February 12, 2025
    weekdayDate: { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }, // Wednesday, 12.06.2026
    weekdayDayMonth: { weekday: 'long', day: 'numeric', month: 'long' }, // Wednesday, February 12
    weekdayDayMonthNumber: { weekday: 'long', day: '2-digit', month: '2-digit' }, // Wednesday, 12.02
    dayMonthYear: { day: '2-digit', month: '2-digit', year: 'numeric' }, // 12.02.2025
    monthYear: { month: 'long', year: 'numeric' }, // February 2025
    dayMonthTextYear: { day: 'numeric', month: 'long', year: 'numeric' }, // 12 February 2025
    dayMonthTextYearTime: { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' } // 12 February 2025 14:30
  },
  de: {
    short: { year: 'numeric', month: '2-digit', day: '2-digit' }, // 12.02.2025
    long: { year: 'numeric', month: 'long', day: 'numeric', weekday: 'long' }, // Mittwoch, 12. Februar 2025
    weekdayDate: { weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric' }, // Mittwoch, 12.06.2026
    weekdayDayMonth: { weekday: 'long', day: 'numeric', month: 'long' }, // Mittwoch, 12. Februar
    weekdayDayMonthNumber: { weekday: 'long', day: '2-digit', month: '2-digit' }, // Mittwoch, 12.02
    dayMonthYear: { day: '2-digit', month: '2-digit', year: 'numeric' }, // 12.02.2025
    monthYear: { month: 'long', year: 'numeric' }, // Februar 2025
    dayMonthTextYear: { day: 'numeric', month: 'long', year: 'numeric' }, // 12. Februar 2025
    dayMonthTextYearTime: { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' } // 12. Februar 2025 14:30
  }


}

export default datetimeFormats